/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  IngestRequestBody2,
  IngestRequestBody2$Outbound,
  IngestRequestBody2$outboundSchema,
} from "../components/ingestrequestbody2.js";

export type IngestLiteLLMGuardrailSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  projectSlugHeaderGramProject?: string | undefined;
};

export type IngestLiteLLMGuardrailRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  ingestRequestBody2: IngestRequestBody2;
};

/** @internal */
export type IngestLiteLLMGuardrailSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "project_slug_header_Gram-Project"?: string | undefined;
};

/** @internal */
export const IngestLiteLLMGuardrailSecurity$outboundSchema: z.ZodMiniType<
  IngestLiteLLMGuardrailSecurity$Outbound,
  IngestLiteLLMGuardrailSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    projectSlugHeaderGramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function ingestLiteLLMGuardrailSecurityToJSON(
  ingestLiteLLMGuardrailSecurity: IngestLiteLLMGuardrailSecurity,
): string {
  return JSON.stringify(
    IngestLiteLLMGuardrailSecurity$outboundSchema.parse(
      ingestLiteLLMGuardrailSecurity,
    ),
  );
}

/** @internal */
export type IngestLiteLLMGuardrailRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  IngestRequestBody2: IngestRequestBody2$Outbound;
};

/** @internal */
export const IngestLiteLLMGuardrailRequest$outboundSchema: z.ZodMiniType<
  IngestLiteLLMGuardrailRequest$Outbound,
  IngestLiteLLMGuardrailRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    ingestRequestBody2: IngestRequestBody2$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      ingestRequestBody2: "IngestRequestBody2",
    });
  }),
);

export function ingestLiteLLMGuardrailRequestToJSON(
  ingestLiteLLMGuardrailRequest: IngestLiteLLMGuardrailRequest,
): string {
  return JSON.stringify(
    IngestLiteLLMGuardrailRequest$outboundSchema.parse(
      ingestLiteLLMGuardrailRequest,
    ),
  );
}
